import type { RefObject } from 'react'

import { createContext } from 'react'

export const HintsScrollContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null)
